import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
import TeamModal from '../../../common/components/Team';
import PaymentModal from '../Payment';
import { getColumns, getNoDataText, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { without, append, filter } from 'ramda';
import { updateInPath, nullsToStrings, } from '../../../../common/utils';

class Teams extends Component {
  constructor(props) {
    super();

    this.state = {
      selectedTeamIds: [],
      paymentModal: {
        opened: false,
        data: []
      },
      teamModal: {
        opened: false,
        data: []
      }
    };
  }

  onRowSelect = (e, { value, checked }) => {
    e.stopPropagation();

    let teamIds;

    if (checked) {
      teamIds = append(value, this.state.selectedTeamIds);
    } else {
      teamIds = without(value, this.state.selectedTeamIds);
    }

    this.setState(s => updateInPath(s, 'selectedTeamIds', teamIds));
  };

  handlePaymentModalClose = (refreshData) => {
    this.setState(s => updateInPath(s, 'paymentModal.opened', false));
    if (refreshData) {
      this.props.refresh();
    }
  }

  handlePaymentModalSave = (data, teams) => {
    this.setState(s => updateInPath(s, 'paymentModal.opened', false));
    this.setState(s => updateInPath(s, 'selectedTeamIds', []));
  };

  handlePaymentModalOpen = () => {
    const selectedTeams = filter(({ teamId }) =>
                                 this.state.selectedTeamIds.includes(teamId),
                                 this.props.data);

    this.setState(s => updateInPath(s, 'paymentModal.data', selectedTeams));
    this.setState(s => updateInPath(s, 'paymentModal.opened', true));
  };

  handleTeamModalClose = (refreshData) => {
    this.setState(s => updateInPath(s, 'teamModal.opened', false));
    if (refreshData) {
      this.props.refresh();
    }
  }

  handleTeamModalSave = (data) => {
    this.setState(s => updateInPath(s, 'teamModal.opened', false));
    this.props.onTeamSave(data);
  };

    handleCompetitionModalEdit = ({ event, competitionId }) => {
    this.props.onCompetitionView(event.id, competitionId, (competition) => {
      this.setState(s => updateInPath(s, 'competitionModal.data', nullsToStrings(competition)));
      this.setState(s => updateInPath(s, 'competitionModal.open', true));
    });
    }
  

  handleTeamModalOpen = ({ teamId, userId }) => {
    this.props.onTeamView(teamId, userId, (team) => {
      this.setState(s => updateInPath(s, 'teamModal.data', nullsToStrings(team)));
      this.setState(s => updateInPath(s, 'teamModal.opened', true));
    });
  }

  handleTeamModalAdd = ({ teamId }) => {
    this.setState(s => updateInPath(s, 'teamModal.data', null));
    this.setState(s => updateInPath(s, 'teamModal.opened', true));
  }

  handleTeamModalDelete = (teamId, userId) => {
    this.setState(s => updateInPath(s, 'teamModal.opened', false));
    this.props.onTeamDelete(teamId, userId);
  };

  render() {
    const { data, events } = this.props;

    const currentYear = (new Date()).getYear();

    // quick hack go show only this year data
    const currentYearData = filter(({event}) => (new Date(event.beginDate)).getYear()  === currentYear, data);

    const paymentModal = this.state.paymentModal,
          teamModal = this.state.teamModal;
    
    return (
      <div>
        { paymentModal.opened && <PaymentModal
                                     open={paymentModal.opened}
                                     data={paymentModal.data}
                                     onClose={this.handlePaymentModalClose}
                                     onSave={this.handlePaymentModalSave} />}
        { teamModal.opened && <TeamModal
                                open={teamModal.opened}
                                data={teamModal.data}
                                events={events}
                                onSave={this.handleTeamModalSave}
                                onDelete={this.handleTeamModalDelete}
                                onClose={this.handleTeamModalClose} />}
        <Header
          onAdd={this.handleTeamModalAdd}
          onPay={this.handlePaymentModalOpen}
          paymentEnabled={!!this.state.selectedTeamIds.length}
        />
        <ReactTable
          className='-striped -highlight'
          data={currentYearData}
          getTrProps={(state, rowInfo, column) => ({
            onClick: e => this.handleTeamModalOpen(rowInfo.original)
          })}
          columns={getColumns(this.onRowSelect)}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE}
          noDataText={getNoDataText()}
        />
      </div>
    );
  };
};

export default Teams;



// WEBPACK FOOTER //
// ./src/private/user/components/Teams/index.js